import { render, staticRenderFns } from "./migrationPresets.vue?vue&type=template&id=0f8017f2&scoped=true"
import script from "./migrationPresets.vue?vue&type=script&lang=js"
export * from "./migrationPresets.vue?vue&type=script&lang=js"
import style0 from "./migrationPresets.vue?vue&type=style&index=0&id=0f8017f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8017f2",
  null
  
)

export default component.exports